// export const base_url = `${window.location.origin}/backend/api/`;
// export const base_url = `http://localhost:5553/api/`;
// export const base_url = `http://192.168.0.44:5552/api/`;
// export const base_url = `https://proposal.nomismasolution.co.uk/backend/api/`;
// export const base_url = `https://testproposal.nomismasolution.co.uk/backend/api/`;
// export const base_url = `https://testproposal.nomismasolution.co.uk/backend/api/`;
// export const base_url = `https://qaproposal.nomismasolution.co.uk/backend/api/`;


export const crm_base_url = `https://crmstaging.nomi.co.uk/crm/staging_group/`;

const isLocalhost = window.location.hostname === "localhost";
export const base_url = isLocalhost
? "http://localhost:5553/api/"
: `${window.location.origin}/backend/api/`;

